import {
  FETCH_ADJUSTMENT_VALUES_REQUEST,
  FETCH_ADJUSTMENT_VALUES_SUCCESS,
  FETCH_ADJUSTMENT_VALUES_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  records: null,
  error: null,
  isLoading: false,
}

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_ADJUSTMENT_VALUES_REQUEST:
      return {
        ...state,
        isLoading: true,
      }

    case FETCH_ADJUSTMENT_VALUES_SUCCESS:
      return {
        ...state,
        records: action.payload,
        error: null,
        isLoading: false,
      }

    case FETCH_ADJUSTMENT_VALUES_ERROR:
      return {
        ...state,
        records: null,
        error: action.payload,
        isLoading: false,
      }

    default:
      return state
  }
}
